import { createUseStyles } from 'react-jss';

export const ToastStyles = createUseStyles({
  TopRight: {
    top: '3.2rem',
    right: '0.75rem',
    transition: 'transform .6s ease-in-out',
    animation: 'toast-in-right .7s',
  },
  BottomRight: {
    bottom: '0.75rem',
    right: '0.75rem',
    transition: 'transform .6s ease-in-out',
    animation: 'toast-in-right .7s',
  },
  TopLeft: {
    top: '3rem',
    left: '0.15rem',
    transition: 'transform .6s ease-in-out',
    animation: 'toast-in-right .7s',
  },
  BottomLeft: {
    bottom: '0.75rem',
    left: '0.15rem',
    transition: 'transform .6s ease-in-out',
    animation: 'toast-in-right .7s',
  },
  '@keyframes toast-in-right': {
    from: { transform: 'translateX(100%)' },
    to: { transform: 'translateX(0)' },
  },
  '@keyframes toast-in-left': {
    from: { transform: 'translateX(-100%)' },
    to: { transform: 'translateX(0)' },
  },
});
